@import '~plyr/src/sass/plyr.scss';

video,
iframe {
  max-width: 100%;
}

:host {
  position: relative;
  display: flex;
}

/** Ensure Accesisbility */
*:focus-visible {
  outline: 2px solid var(--presto-player-focus-outline, white) !important;
}

/*
Fix the iOS fullscreen not centered issue.
This issue is with underlying plyr.io
https://github.com/prestomade/presto-player/issues/140
*/
.plyr--html5 .plyr__video-wrapper,
.plyr--youtube .plyr__video-wrapper {
  height: 100%;
}

.plyr__video-wrapper {
  z-index: 1;
}

.presto-player__wrapper {
  position: relative;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol';
  width: 100%;

  &.rtl {
    direction: rtl;
  }

  .plyr__progress__marker {
    height: 14px;
  }


  // make sure images are responsive
  img {
    max-width: 100%;
  }

  .plyr {
    border-radius: var(--presto-player-border-radius);
    // iframe {
    //   border-radius: var(--presto-player-border-radius);
    // }

    &.plyr--video.plyr--menu-open {
      overflow: hidden;
    }
  }

  .plyr--fullscreen-fallback.plyr--vimeo .plyr__video-wrapper {
    top: 50%;
    transform: translateY(-50%);
  }

  // pesky ios bug with rounded corners
  .plyr--fullscreen-fallback {
    &.plyr {
      border-radius: 0 !important;
      iframe {
        border-radius: 0 !important;
      }
    }
  }

  .plyr__menu__container {
    overflow: auto;

    &:after {
      display: none;
    }
  }
  img {
    border: none;
  }

  video {
    margin: auto;
  }

  iframe {
    height: 100%;
  }

  .plyr--video .plyr__control:active,
  .plyr--video .plyr__control:focus {
    background: #00b3ff;
    background: var(--plyr-video-control-background-hover, var(--plyr-color-main, var(--plyr-color-main, #00b3ff)));
    color: #fff;
    color: var(--plyr-video-control-color-hover, #fff);
  }

  .plyr {
    &__poster {
      background-size: cover;
      z-index: 2;
    }
  }

  .plyr__tooltip--label {
    br {
      display: none;
    }
  }

  .presto-player__logo {
    margin: 0;
    display: block;
    position: absolute;
    z-index: 3;
    opacity: 0.5;
    object-fit: contain;
    transition: bottom 0.4s ease-in-out;
    max-width: var(--presto-player-logo-width, 75px);

    &.is-bottom-right {
      left: auto;
      right: 20px;
      top: auto;
      bottom: 60px;
    }
    &.is-bottom-left {
      left: 20px;
      right: auto;
      top: auto;
      bottom: 60px;
    }
  }

  @media screen and (min-width: 380px) {
    &.presto-player--hide-controls,
    .plyr--hide-controls {
      .presto-player__logo {
        &.is-bottom-right,
        &.is-bottom-left {
          bottom: 20px;
        }
      }
    }
  }

  presto-search-bar {
    transition: opacity 0.3s ease, transform 0.3s ease;
  }
  &.presto-player--hide-controls {
    presto-search-bar {
      opacity: 0;
      transform: translateY(-100%);
    }
  }

  .presto-player-progress__marker {
    width: 16px;
    height: 16px;
    padding: 0;
    border: 2px solid rgba(255, 255, 255, 0.5);
    position: absolute;
    border-radius: 9999px;
    bottom: calc(50% - 8px);
    z-index: 9;
    margin-left: -8px !important;
  }

  // show youtube related videos at the end
  &.presto-player--ended .plyr--youtube .plyr__poster {
    display: none;
  }
  &.presto-player--ended .plyr--youtube .plyr__control.plyr__control--overlaid {
    display: none;
  }

  // make sure it always goes over the top of controls.
  .presto-player__wrapper .plyr__control--overlaid {
    z-index: 4;
  }

  // beaver builder conflict
  button.plyr__control.plyr__control--overlaid:focus {
    background: inherit;
    border: none;
    outline: 0;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  .plyr__controls__item.plyr__progress__container {
    position: relative;
  }

  .plyr--full-ui.plyr--video input[type='range']::-webkit-slider-runnable-track {
    box-shadow: none;
  }

  .plyr--video .plyr__controls {
    background: var(--plyr-video-controls-background, linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.15), rgba(0, 0, 0, 0.25), rgba(0, 0, 0, 0.75)));
  }

  // add extra padding for phones with bottom touch elements.
  .plyr--fullscreen-fallback.plyr--video .plyr__controls {
    padding-bottom: calc(var(--plyr-control-spacing, 10px) + env(safe-area-inset-bottom));
  }

  .presto-player-toc {
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol';
    line-height: 1.4;
    position: absolute;
    top: auto;
    right: 0;
    left: 0;
    bottom: 0;
    max-height: calc(100%);
    max-width: calc(100%);
    background: rgba(255, 255, 255, 0.9);
    background: var(--plyr-menu-background, rgba(255, 255, 255, 0.9));
    left: auto;
    padding: 20px 15px;
    border-radius: 4px;
    width: 100%;
    z-index: 9;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.15);
    box-shadow: var(--plyr-menu-shadow, 0 1px 2px rgba(0, 0, 0, 0.15));
    color: #4a5464;
    color: var(--plyr-menu-color, #4a5464);
    font-size: 15px;
    font-size: var(--plyr-font-size-base, 15px);
    white-space: nowrap;
    z-index: 3;
    display: flex;
    flex-direction: column;
    transition: bottom 0.25s ease;

    @media screen and (min-width: 380px) {
      right: 20px;
      bottom: 60px;
      width: 300px;
      max-height: calc(100% - 80px);
      max-width: calc(100vw - 70px);
    }

    &__wrapper {
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      z-index: 3;
      visibility: hidden;
      opacity: 0;
      transition: opacity 0.3s ease-in-out, visibility 0.3s ease-in-out;
      &.is-showing {
        visibility: visible;
        opacity: 1;
      }
    }

    &__cover {
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      z-index: 3;
    }

    &__list {
      flex: 1;
      overflow: auto;
    }

    &__title {
      font-size: 12px;
      font-weight: bold;
      margin-bottom: 10px;
      margin-left: 10px;
      margin-right: 10px;
      display: none;
    }

    @media screen and (min-width: 380px) {
      &__title {
        display: block;
      }
    }

    &__name {
      white-space: nowrap;
      overflow: hidden;
      width: 100%;
      text-overflow: ellipsis;
    }

    &__chapter {
      padding: 12px;
      border-radius: 3px;
      cursor: pointer;
      line-height: 1;
      display: flex;
      align-items: center;
      transition: background-color 0.4s ease, color 0.4s ease;
      margin-bottom: 2px;
      position: relative;

      &:last-child {
        margin-bottom: 0;
      }

      &.is-highlighted,
      &:hover {
        background: #00b3ff;
        background: var(--plyr-video-control-background-hover, var(--plyr-color-main, var(--plyr-color-main, #00b3ff)));
        color: #fff;
        color: var(--plyr-video-control-color-hover, #fff);
      }

      &.is-highlighted {
        padding-right: 30px;
      }

      &.is-highlighted:after {
        background: rgba(255, 255, 255, 0.5);
        content: '';
        display: block;
        flex-shrink: 0;
        height: 8px;
        width: 8px;
        margin-right: 10px;
        margin-right: var(--plyr-control-spacing, 10px);
        transition: all 0.3s ease;
        border-radius: 9999px;
        position: absolute;
        right: 7px;
      }
    }

    &__order {
      margin-right: 12px;
      opacity: 0.5;
    }
  }

  &.rtl {
    direction: rtl;
    .presto-player-toc__order {
      order: 2;
      margin-left: 12px;
      margin-right: 0;
    }
    .presto-player-toc__name {
      direction: rtl;
    }
  }

  &.action-bar-active {
    .presto-audio__poster {
      img {
        border-bottom-left-radius: 0px;
      }
    }
  }

  .presto-player-error {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.9);
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10;
    text-align: center;

    &__title {
      font-size: 18px;
      font-weight: bold;
      margin-bottom: 8px;
    }
    &__description {
      opacity: 0.75;
    }
  }

  // hides related videos on pause
  &.hide-youtube-ui .plyr__video-embed iframe {
    top: -50%;
    height: 200%;
  }

  // Hotfix for Vimeo video on iOS device
  .plyr--vimeo.plyr--playing {
    .plyr__video-embed__container {
      pointer-events: none;
    }
  }

  .plyr__control--overlaid {
    border-radius: 6px;
    padding-left: 26px;
    padding-right: 26px;
    position: absolute !important;
    top: 50% !important;
  }

  &.presto-player--hide-scrim .plyr__controls {
    background: transparent;
  }

  presto-audio .presto-player-toc {
    max-height: 350px;
  }
  presto-action-bar {
    position: relative;
    z-index: 1;
  }
}

.presto-sticky-parent {
  z-index: 99998; // 1 less than admin bar
}

.presto-sticky-audio {
  position: fixed;
  z-index: 3000;
  width: 100vw;
  bottom: 0px;
  right: 0px;
  left: 0px;
}

@media screen and (min-width: 960px) {
  .presto-sticky {
    --presto-sticky-space: 15px;
    position: fixed;
    z-index: 3000;
    max-width: var(--presto-sticky-width, 380px);
    // top: auto;
    // bottom: var(--presto-sticky-space);
    // right: var(--presto-sticky-space);
    // transform: translateY(-15px);
    width: 100vw;

    .plyr__controls,
    .presto-player-toc__wrapper,
    presto-action-bar,
    .presto-player__logo {
      display: none;
    }
    &--top-left {
      top: var(--presto-sticky-space);
      left: var(--presto-sticky-space);
    }
    &--top-center {
      top: var(--presto-sticky-space);
      left: 0;
      right: 0;
      margin: 0 auto;
    }
    &--top-right {
      top: var(--presto-sticky-space);
      right: var(--presto-sticky-space);
    }
    &--center-left {
      top: 0;
      bottom: 0;
      margin: auto 0;
      left: var(--presto-sticky-space);
      display: flex;
      align-items: center;
    }
    &--center-center {
      top: 0;
      bottom: 0;
      right: 0;
      left: 0;
      margin: auto;
      display: flex;
      align-items: center;
    }
    &--center-right {
      top: 0;
      bottom: 0;
      margin: auto 0;
      right: var(--presto-sticky-space);
      display: flex;
      align-items: center;
    }
    &--bottom-left {
      bottom: var(--presto-sticky-space);
      left: var(--presto-sticky-space);
    }
    &--bottom-center {
      bottom: var(--presto-sticky-space);
      left: 0;
      right: 0;
      margin: 0 auto;
    }
    &--bottom-right {
      bottom: var(--presto-sticky-space);
      right: var(--presto-sticky-space);
    }
  }
}

.presto-player {
  &__overlay {
    position: absolute;
    top: 50%;
    left: 50%;
    z-index: 3;
  }
  &__muted-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: none;
    align-items: center;
    justify-content: center;

    .plyr__control--overlaid {
      display: block;
      opacity: 1;
      visibility: visible;
    }
  }

  &__wrapper {
    &.is-muted-overlay {
      cursor: pointer;

      &.presto-player--playing .presto-player__muted-overlay {
        display: flex;
      }

      .plyr--playing .presto-player__muted-overlay .plyr__control--overlaid {
        opacity: 1;
        visibility: visible;
      }

      .presto-player__logo {
        display: none;
      }
      .plyr__controls {
        display: none;
      }
    }

    &.is-muted-overlay .plyr .plyr__controls:not(:empty) ~ .plyr__captions {
      transform: translateY(0) !important;
    }

    &.rtl .plyr__captions {
      direction: rtl;
    }

    .plyr__captions {
      z-index: 1;
    }

    &.caption-style-full {
      .plyr__captions {
        background: var(--plyr-captions-background, rgba(0, 0, 0, 0.8));
        padding-top: 0;
        padding-bottom: 0;
      }
      .plyr:not(.plyr--hide-controls):not(.is-muted-overlay) .plyr__controls:not(:empty) ~ .plyr__captions {
        transform: translateY(calc(var(--plyr-control-spacing, 13px) * -4));
      }
      &.skin-stacked {
        .plyr:not(.plyr--hide-controls):not(.is-muted-overlay) .plyr__controls:not(:empty) ~ .plyr__captions {
          transform: translateY(calc(var(--plyr-control-spacing, 17px) * -4));
        }
      }
    }
  }
  &__play-cover {
    cursor: pointer;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 99;
  }

  &__chapters {
    width: 100%;
    position: absolute;
    top: 0;
    height: 100%;
  }

  &__chapter-markers {
    margin: 0 8px;
    height: 100%;
    position: relative;
  }

  &-progress__marker.plyr__controls__item.plyr__control:hover {
    border: 0;
    background: #fff;
  }
}

/*
* This CSS is duplicated in 'inc/Services/Scripts.php'
*/

.presto-iframe-fallback-container {
  position: relative;
  padding-bottom: 56.25%;
  padding-top: 30px;
  height: 0;
  overflow: hidden;
}
.presto-iframe-fallback-container embed,
.presto-iframe-fallback-container iframe,
.presto-iframe-fallback-container object {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

/*
  The youtube hide ui hack works only when container is in fixed aspect ratio.
  When in fullscreen mode the container isn't in aspect ratio.
  The aspect ratio in full screen needs to be done
  we need to calculate width based on available height to create
  responsive 16x9 container.
*/
@media (min-aspect-ratio: 16/9) {
  .hide-youtube-ui {
    presto-youtube {
      .plyr:fullscreen {
        .plyr__video-wrapper {
          width: calc(calc(1600 / 9) * 1vh);
        }
      }
    }
  }
}
.cta-email-active,
.cta-email-active .presto-audio__wrapper {
  min-height: 140px;
}

.cta-active,
.email-active,
.cta-active .presto-audio__wrapper,
.email-active .presto-audio__wrapper {
  min-height: 140px;
}

.action-bar-active {
  .plyr {
    border-radius: var(--presto-player-border-radius) var(--presto-player-border-radius) 0px 0px;
  }
}

presto-search-bar {
  position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 70px;
    background: var(--plyr-video-controls-background, linear-gradient(rgba(0, 0, 0, 0.75),rgba(0, 0, 0, 0.45),rgba(0, 0, 0, 0.35), rgba(0, 0, 0, 0.15), rgba(0, 0, 0, 0)));
    z-index: 1;
}
presto-search-bar-ui {
  position: absolute;
  top: 15px;
  right: 23px;
}
